import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/cssbuy-spreadsheet-guide/page";
import ShoppingGuidePage from "../pages/article/shopping-guide/page";
import QCGuidePage from "../pages/article/how-to-qc/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/cssbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/article/shopping-guide",
    element: <ShoppingGuidePage />,
  },
  {
    path: "/article/how-to-qc",
    element: <QCGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;